/** Deterministic civilization naming, independent of geometry. */
import { generatedSettlementName } from "./names.js";

/** Mixed linguistic and cultural traditions, stable for the settlement seed. */
export function settlementName(seed: string): string {
  return generatedSettlementName(seed);
}
